import axios from 'axios';

// API 基础配置
const API_BASE_URL = 'https://hot-update-service.ejfuowek.workers.dev';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add any auth headers or other request modifications here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // For most APIs, just return data
    // But preserve status for cases where we need to differentiate
    if (response.config.url?.includes('/api/ip-whitelist') && response.config.method === 'post') {
      // For IP whitelist POST, we want to know if it was 200 (already exists) or 201 (newly added)
      return {
        ...response.data,
        __httpStatus: response.status
      };
    }
    return response.data;
  },
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

// Configuration API Types
export interface ConfigEntry {
  env: string;
  platform: string;
  url: string;
}

// Configuration API Functions
export const fetchConfig = async (): Promise<ConfigEntry[]> => {
  return api.get('/api/config');
};

export const updateConfig = async (configEntries: ConfigEntry[]): Promise<{ message: string; updatedCount: number }> => {
  return api.post('/api/config', configEntries);
};

// IP Whitelist API Functions
export const fetchIpWhitelist = async (): Promise<string[]> => {
  return api.get('/api/ip-whitelist');
};

export const addIpToWhitelist = async (ip: string): Promise<{ message: string; ip: string }> => {
  return api.post('/api/ip-whitelist', { ip });
};

export const removeIpFromWhitelist = async (ip: string): Promise<{ message: string; ip: string }> => {
  return api.delete('/api/ip-whitelist', { data: { ip } });
};

export default api;

 